exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pro .tips[data-v-13fcb04a]{height:50px;line-height:50px;color:#999;font-size:12px;border-bottom:1px solid rgba(0,0,0,.05)}.pro .btn-box[data-v-13fcb04a]{padding-bottom:20px}", ""]);

// exports
